<template>
	<div id="Vote">
		<div class="Vote">
			<div class="search">
				<input type="text" placeholder="请输入姓名或编号" v-model="keyword" maxlength="16">
				<img :src="imgPath+'search.png'" v-show="!keyword">
				<van-icon name="clear" class="clear" v-show="keyword" @click="clearSearch"/>
			</div>

			<div v-show="!keyword">
				<div class="notice">
					<img :src="imgPath+'notice.png'" alt="">
					<span>本次投票有效截止时间至：{{end_time}} <span v-if="ended">(已结束)</span></span>
				</div>

				<div class="nums clearfix">
					<div class="players fl">
						<h4>{{initData.player_num}}</h4>
						<p>参赛选手</p>
					</div>
					<div class="tickets fr">
						<h4>{{initData.total_vote_num}}</h4>
						<p>累积投票</p>
					</div>
				</div>

				<van-tabs v-model="active" @click="loadData">
					<van-tab title="全部参赛">
						<ul class="playerList clearfix" v-if="all_player.length" v-waterfall-lower="getData" waterfall-disabled="disabled" waterfall-offset="100">
							<li class="fl" v-for="(item,index) in all_player" :key="index">
								<div class="img"><img :src="item.pic_url" alt=""></div>
								<div class="title">
									<div class="clearfix">
										<div class="fl">{{item.name}}</div>
										<div class="fr">{{item.total}}票</div>
									</div>
									<div class="btn" @click="showPay(item)" v-if="!ended">投票</div>
									<div class="btn disabled" v-else>投票</div>
								</div>
								<div class="tip">{{item.code}}</div>
							</li>
						</ul>
						<div v-else class="nothing">
				            <img :src="imgPath+'nothing.png'" alt="暂无数据">
				        </div>
					</van-tab>

					<van-tab title="今日最佳">
						<div class="bestBox">
							<img :src="imgPath+'todayBest.png'" class="bestImg">
							<div class="best">
								<ul class="clearfix">
									<li class="fl">
										<div class="btn">最佳选手</div>
										<template v-if='best_player.player_id'>
											<div class="user clearfix">
												<div class="img fl"><img :src="best_player.player_pic_url" :alt="best_player.player_name"></div>
												<div class="fl">
													<h4>{{best_player.player_name}}</h4>
													<span>NO.{{best_player.player_code}}</span>
												</div>
											</div>
											<p>今日票数: <span>+{{best_player.today_num}}</span> 票<img :src="imgPath+'rise.png'"></p>
											<p>总票数: <span>{{best_player.total_num}}</span> 票</p>
										</template>
										<div v-else class="nothing">
								            <img :src="imgPath+'nothing.png'" alt="暂无数据">
								        </div>
									</li>
									<li class="fl">
										<div class="btn">最佳观众</div>
										<template v-if='best_fanser.fans_id || best_fanser.nick'>
											<div class="user clearfix">
												<div class="img fl"><img :src="best_fanser.header" :alt="best_fanser.nick"></div>
												<div class="fl">
													<h3>{{best_fanser.nick}}</h3>
												</div>
											</div>
											<p>赠送礼物: <span>+{{best_fanser.gift_num}}</span> 个</p>
											<p v-if="support_player.length">支持选手: <img class="head" :src="item.player_pic_url" v-for="(item,index) in support_player" :key="index"></p>
										</template>
										<div v-else class="nothing">
								            <img :src="imgPath+'nothing.png'" alt="暂无数据">
								        </div>
									</li>
								</ul>
							</div>
						</div>
					</van-tab>

					<van-tab title="排名">
						<div v-if="playerList.length">
							<ul class="Ranking clearfix">
								<li class="fl">
									<div class="img">
										<img class="head" :src="playerList[1].imageUrl">
										<img class="index" :src="imgPath+'index2.png'">
									</div>
									<h3>{{playerList[1].name}}</h3>
									<h4>NO.{{playerList[1].code}}</h4>
									<p>{{playerList[1].total}}票</p>
									<div class="btn" @click="showPay(playerList[1])" v-if="!ended">投票</div>
									<div class="btn disabled" v-else>投票</div>
								</li>
								<li class="one fl">
									<div class="img">
										<img class="head" :src="playerList[0].imageUrl">
										<img class="index" :src="imgPath+'index1.png'">
									</div>
									<h3>{{playerList[0].name}}</h3>
									<h4>NO.{{playerList[0].code}}</h4>
									<p>{{playerList[0].total}}票</p>
									<div class="btn" @click="showPay(playerList[0])" v-if="!ended">投票</div>
									<div class="btn disabled" v-else>投票</div>
								</li>
								<li class="fl">
									<div class="img">
										<img class="head" :src="playerList[2].imageUrl">
										<img class="index" :src="imgPath+'index3.png'">
									</div>
									<h3>{{playerList[2].name}}</h3>
									<h4>NO.{{playerList[2].code}}</h4>
									<p>{{playerList[2].total}}票</p>
									<div class="btn" @click="showPay(playerList[2])" v-if="!ended">投票</div>
									<div class="btn disabled" v-else>投票</div>
								</li>
							</ul>

				            <div class="listBox" v-waterfall-lower="getRank" waterfall-disabled="disabled2" waterfall-offset="100">
				                <ul class="list" id="lists">
				                    <li v-for="(item,index) in playerList" :key="index" class="clearfix" v-if="index > 2">
				                        <div class="img"><img :src="item.imageUrl"></div>
				                        <div class="content">
				                            <h4><span>NO.{{item.code}}</span><p>{{item.name}}</p></h4>
				                            <div class="number">
				                                <p>礼物数：<span>{{item.pay_vote_num}} 个</span></p>
				                                <p>总票数：<span>{{item.total}} 票</span></p>
				                            </div>
				                        </div>
				                        <div class="btn" @click="showPay(item)" v-if="!ended">投票</div>
				                        <div class="btn disabled" v-else>投票</div>
				                    </li>
				                </ul>
				            </div>
						</div>
						<div v-else class="nothing">
				            <img :src="imgPath+'nothing.png'" alt="暂无数据">
				        </div>
					</van-tab>

					<van-tab title="活动规则">
						<div class="rules" v-dompurify-html="remark">
							{{remark}}
						</div>
					</van-tab>
				</van-tabs>
			</div>

			<div v-show="keyword" class="searched">
				<h4>搜索结果</h4>
				<ul class="playerList clearfix" v-if="searchList.length">
					<li class="fl" v-for="(item,index) in searchList" :key="index">
						<div class="img"><img :src="item.pic_url"></div>
						<div class="title">
							<div class="clearfix">
								<div class="fl">{{item.name}}</div>
								<div class="fr">{{item.total}}票</div>
							</div>
							<div class="btn" @click="showPay(item)" v-if="!ended">投票</div>
			                <div class="btn disabled" v-else>投票</div>
						</div>
						<div class="tip">{{item.code}}</div>
					</li>
				</ul>
				<div v-else class="nothing">
		            <img :src="imgPath+'nothing.png'" alt="暂无数据">
		        </div>
			</div>
		</div>


		<van-popup v-model="show" position="bottom">
			<div class="voteingBox">
				<div class="title">支持{{PlayerName}}</div>
				<div class="voteing">
					<ul class="ticktes">
						<li @click="checkType(-1)" :class="{cur:(giftType == -1)}">
							<div class="img" v-if="setting.free_gift_url"><img :src="setting.free_gift_url"></div>
							<div class="img" v-else><img :src="imgPath+'ticket.png'"></div>
							<h4>免费票</h4>
							<p>(每天限投{{setting.limit}}票)</p>
						</li>
						<li @click="checkType(index,item)" :class="{cur:(giftType == index)}" v-for="(item,index) in gifts" :key="index">
							<div class="img"><img :src="item.gift_pic_url"></div>
							<h4>{{item.name}}</h4>
							<p>({{item.rate}}票/{{item.price/100}}元)</p>
						</li>
					</ul>

					<div class="count" v-if="giftType != -1">
						<div class="cut" @click="cut" v-if="giftNum > 1">-</div>
						<div class="cut disabled" v-else>-</div>
						<input type="text" v-model="giftNum">
						<div class="add" @click="add">+</div>
					</div>
					<div class="count" v-else></div>

					<div class="btn" v-if="giftType == -1" @click="voteing">投票</div>
					<div class="btn" v-else @click="pay">投票({{price}}元)</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>

import { Toast } from 'vant';
import tool from '../../../kits/Tools.js';
import md5 from 'blueimp-md5';
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
Vue.use(Tab).use(Tabs);
import { Waterfall } from 'vant';
import { Popup } from 'vant';
Vue.use(Popup);
import { Icon } from 'vant';
Vue.use(Icon);

	export default {
		data() {
			return {
				fans_id:'',
				initData:'',
				ended:false,
				imgPath:'',
				active:0,
				show:false,
				giftId:0,
				giftNum:1,
				giftPrice:0,
				giftType:-1,
				baseUrl:'http://plive.shikee.tv/vote/',
				page:1,
				page_nums:8,
				disabled:false,
				end_time:'',
				setting:{},
				gifts:[],
				all_player:[],
				PlayerName:'',
				best_player:{},
				best_fanser:{},
				support_player:[],
				loadedOne:false,
				loaded1:false,
				loaded2:false,
				playerList:[],
				remark:'',
				keyword:'',
				searchList:[],
				page2:1,
				page_nums2:8,
				disabled2:false,
				uid:'',
				player_id:''
			}
		},
		directives: {
			WaterfallLower: Waterfall('lower'),
			WaterfallUpper: Waterfall('upper')
		},
		props:['mid','vid','currentMid'],
		mounted(){
			if(/^(.missmakelive.)/.test(location.hostname)){
				this.baseUrl = 'http://Plive.shikee.tv/vote/';
			}
			this.imgPath = tool.imgPath()+'vote/';
			
			var current_app_Id = window.localStorage.getItem("current_app_Id");
			var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
			this.fans_id = fans.fans_id;
			
		},
		watch:{
			currentMid(){
				if(!this.loaded && this.currentMid == this.mid){
					this.getData();
				}
			},
			giftNum:function(val){
				var that = this;
				if(val < 0){
					Toast("礼物数量不能小于0");
					setTimeout(function(){
						that.giftNum = 0;
					},1000)
					return;
				}
				if(!/^[0-9]*$/.test(val)){
					Toast("请输入正确的数字");
					setTimeout(function(){
						that.giftNum = 0;
					},1000)
					return;
				}
			},
			keyword:function(val){
				if(val){
					this.search();
				}
			},
			show(curVal, oldVal) {
				this.$emit('switchSider');
			},
		},
		computed:{
			price:function(){
				return this.giftNum*this.giftPrice/100;
			}
		},
		methods: {
			getData() {
				var that = this;
				var option = 'vid='+this.vid+'&page_nums='+this.page_nums+'&page='+this.page;
				if(this.active != 0){
					return;
				}
				if(this.loadedOne){
					return;
				}
				this.loadedOne = true;
				Toast.loading({
					mask: true,
					message: '加载中...'
				});
				this.axios.post(this.baseUrl+'vote/init',option).then(function(data){
					var data = data.data;
					Toast.clear();
	                if(data.code == 200) {
	                	if(that.page == 1){
		                	that.initData = data.data;
		                	that.end_time = that.initData.vote.end_time;
		                	that.setting = that.initData.setting;
		                	that.gifts = that.initData.gift;
		                	that.uid = that.initData.vote.uid;
	                		that.remark = that.setting.remark;
	                		if((new Date(that.end_time)).getTime() < (new Date()).getTime()){
	                			that.ended = true;
	                		}
	                	}
						
	                	that.all_player = that.all_player.concat(data.data.all_player);
	                	that.page++;
	                	if(data.data.all_player.length < that.page_nums){
	                		that.disabled = true;
	                	}
					} else {
						console.log("获取介绍失败"+data.message);
					}
					that.loadedOne = false;
            	}).catch(function(){
					that.loadedOne = false;
					Toast.clear();
				//Toast("获取介绍失败");
            	})
			},
			search(){
				var that = this;
				var option = 'vid='+this.vid+'&page_nums=100&page=1&keyword='+this.keyword;
				Toast.loading({
					mask: true,
					message: '搜索中...'
				});
				this.axios.post(this.baseUrl+'vote/init',option).then(function(data){
					var data = data.data;
					Toast.clear();
	                if(data.code == 200) {
	                	that.searchList = data.data.all_player;
					} else {
						console.log("获取介绍失败");
					}
            	}).catch(function(){
					Toast.clear();
				//Toast("获取介绍失败");
            	})
			},
			showPay(item){
				this.show = true;
				this.PlayerName = item.name;
				this.player_id = item.player_id;
			},
			add(){
				this.giftNum++;
			},
			cut(){
				if(this.giftNum > 1){
					this.giftNum--;
				}
			},
			checkType(index,item){
				this.giftType = index;
				if(index >= 0){
					this.giftPrice = item.price;
					this.giftId = item.id;
				}else{
					this.giftPrice = 0;
					this.giftId = 0;
				}
			},
			loadData(index,title){
				this.active = index;
				console.log(this.active);
				if(index == 1 && !this.loaded1){
					this.getBest();
				}
				if(index == 2 && !this.loaded2){
					this.getRank();
				}
			},
			getBest(){
				var that = this;
				var option = 'vid='+this.vid;
				Toast.loading({
					mask: true,
					message: '加载中...'
				});
				this.loaded1 = true;
				this.axios.post(this.baseUrl+'vote/todayBest',option).then(function(data){
					var data = data.data;
					Toast.clear();
					if(data.code == 200){
						that.loaded1 = false;
						that.best_player = data.data.best_player;
						that.best_fanser = data.data.best_fanser;
						that.support_player = data.data.support_player;
					}
				}).catch(function(data){
					Toast.clear();
					console.log(data);
				})
			},
			getRank(){
				var that = this;
				var option = 'vid='+this.vid+'&page_nums='+this.page_nums2+'&page='+this.page2;
				if(this.active != 2){
					return;
				}
				
				if(that.loaded2){
					return;
				}
				
				Toast.loading({
					mask: true,
					message: '加载中...'
				});
				
				that.loaded2 = true;
				this.axios.post(this.baseUrl+'index/playerList',option).then(function(data){
					var data = data.data;
					Toast.clear();
					if(data.code == 200){
						that.loaded2 = false;
						that.page2++;
						that.playerList = that.playerList.concat(data.data);
						if(data.data.length < that.page_nums2){
							that.disabled2 = true;
						}
					}else{

					}
				}).catch(function(data){
					Toast.clear();
					console.log(data);
				})
			},
			clearSearch(){
				this.keyword = '';
			},
			voteing(){
				let Base64 = require('js-base64').Base64;
				var that = this;
				var option = '';
				var data = {
					'vid': this.vid,
					'player_id': this.player_id,
					'fans_id': this.fans_id
				};
				
				console.log(data);
				
				option += 'key=' + md5(JSON.stringify(data) + "missmakelive@msmk") + "&data=" + Base64.encode(JSON.stringify(data));

				this.axios.post(this.baseUrl+'index/play',option).then(function(data){
					var data = data.data;
					if(data.code == 200){
						Toast('投票成功');
						setTimeout(function(){
							that.show = false;
							that.reload();
						},1500)
					}else{
						Toast(data.message);
					}
				}).catch(function(data){
					Toast.clear();
					console.log(data);
				})
			},
			pay(){
				var that = this;
				var option = 'vid='+this.vid+'&player_id='+this.player_id+'&fans_id='+this.fans_id+'&gift_num='+this.giftNum+'&uid='+this.uid+'&gift_id='+this.giftId;
				if(this.giftNum == 0){
					Toast('礼物数不能为0');
					return;
				}
				this.axios.post(this.baseUrl+'index/rewardGift',option).then(function(data){
					var data = data.data;
					Toast.clear();
					if(data.code == 200){
						that.weixinPay(data.data);
					}else{
						Toast(data.message);
					}
				}).catch(function(data){
					Toast.clear();
					console.log(data);
				})
			},
			weixinPay(p) {
				var that = this;
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
						"appId": p.appId, //公众号名称，由商户传入     
						"timeStamp": String(p.timeStamp), //时间戳，自1970年以来的秒数     
						"nonceStr": p.nonceStr, //随机串     
						"package": p.package,
						"signType": p.signType, //微信签名方式：
						"paySign": p.paySign //微信签名 
					},
					function(res) {
						// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
						if(res.errMsg == "get_brand_wcpay_request:ok" || res.err_msg == "get_brand_wcpay_request:ok") {
							Toast('赠送礼物成功');
							setTimeout(function(){
								that.show = false;
								that.reload();
							},1000)
						}
					});
			},
			reload(){
				if(this.active == 0){
					this.page = 1;
					this.all_player = [];
					this.getData();
				}else if(this.active == 2){
					this.page2 = 1;
					this.playerList = [];
					this.getRank();
				}else{
					this.page = 1;
					this.all_player = [];
					this.getData();

					this.page2 = 1;
					this.playerList = [];
					this.getRank();
				}
				if(this.keyword){
					this.search();
				}
			}
		}
	}
</script>

<style scoped>
#Vote{
	background: #2c2e35;
}
.Vote{
	padding:15px;
	height: 100%;
	overflow: scroll;
	box-sizing: border-box;
}
.search{
	margin: 0 16px;
	height: 44px;
	line-height: 44px;
	border-radius: 5px;
	background: #fff;
	color: #767175;
	text-align: center;
	position: relative;
}
.search input{
	display: block;
	border: none;
	background: none;
	width: 100%;
	text-align: center;
}
.search img{
	position: absolute;
	top: 14px;
	left: 50%;
	margin-left: -80px;
	width: 16px;
}
.search .clear{
	position: absolute;
	top: 13px;
	right: 10px;
	font-size: 18px;
}
.searched h4{
	height: 40px;
	line-height: 40px;
	text-align: center;
	color: #fff;
}
.notice{
	color: #fff;
	height: 30px;
	line-height: 30px;
	margin-top: 20px;
	font-size: 11px;
}
.notice img{
	vertical-align: middle;
	width: 12px;
	margin-right: 5px;
}
.nums{
	margin: 8px 0;
	background: #dcb45a;
	color: #272727;
	text-align: center;
	border-radius: 5px;
	padding: 20px 0;
}
.nums .players{
	border-right: 1px solid #a38137;
}
.nums .players,.nums .tickets{
	width: 49.6%;
	height: 40px;
}
.nums h4{
	font-size: 20px;
	line-height: 25px;
}
.nums p{
	font-size: 11px;
	line-height: 15px;
}
.playerList{
	margin: 10px -7px;
	min-height: 240px;
}
.playerList li{
	padding:0 7px;
	margin: 7px 0;
	width: 50%;
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
}
.playerList .img{
	width: 100%;
	overflow: hidden;
	position: relative;
	padding-bottom: 100%;
	background: #38393c;
}
.playerList .img img{
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	transform: translateY(-50%);
}
.playerList .title{
	background: #fff;
	line-height: 36px;
	overflow: hidden;
	padding: 0 10px 10px;
	color: #313131;
}
.playerList .title .fr{
	color: #d4ae5a;
}
.btn{
	display: block;
	border-radius: 5px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	background: linear-gradient(#f2ce7d,#c59934);
	font-size: 15px;
	color: #fff;
}
.btn.disabled{
	background: linear-gradient(#ccc,#999);
}
.playerList .tip{
	position: absolute;
	top: 0;
	left: 14px;
	width: 28px;
	height: 20px;
	line-height: 20px;
	background: #aeadb1;
	color: #fff;
	text-align: center;
}
.playerList .tip:after{
	content: '';
	display: block;
	position: absolute;
	width: 0;
	height: 0;
	bottom: -10px;
	left: 0;
	border-left: 14px solid #aeadb1;
	border-right: 14px solid #aeadb1;
	border-bottom: 10px solid transparent;
	border-top: 10px solid transparent;
}
.bestBox{
	padding-top: 45px;
	position: relative;
}
.bestBox .bestImg{
	position: absolute;
	width: 85px;
	top: 12px;
	left: 50%;
	margin-left: -42px;
}
.best{
    border-radius: 10px;
    background: linear-gradient(#f3cf7f, #c49833);
    padding: 3px;
}
.best ul{
	background: #212226;
	border-radius: 7px;
}
.best li{
	width: 50%;
	padding: 8px 8px 18px;
	box-sizing: border-box;
	min-height: 240px;
}
.best li .nothing{
	margin-top: 40px;
}
.best .btn{
	color: #000000;
}
.best  .user{
	margin-top: 28px;
	margin-bottom: 10px;
	height: 42px;
	overflow: hidden;
}
.best .img{
	width: 40px;
	height: 40px;
	border-radius: 20px;
	overflow: hidden;
	border: 1px solid #aa925e;
	margin-right: 10px;
}
.best .img img{
	width: 100%;
}
.best .user h4{
	font-size: 16px;
	color: #f3cf7f;
	line-height: 26px;
}
.best .user p{
	font-size: 11px;
	color: #fff;
}
.best .user h3{
	line-height: 40px;
	font-size: 16px;
	color: #f3cf7f;
}
.best p{
	line-height: 32px;
	color: #fff;
}
.best p span{
	color: #f3cf7f;
}
.best p img{
	height: 14px;
	vertical-align: middle;
}
.best p .head{
	width: 25px;
	height: 25px;
	margin-right: 5px;
	border-radius: 50%;
	border: 1px solid #d6ad50;
}
.Ranking{
	padding: 44px 0 20px;
	display: flex;
	align-items: flex-end;
	color: #fff;
	min-height: 240px;
}
.Ranking li{
	width: 31.5%;
	padding: 0 3px;
	text-align: center;
	box-sizing: border-box;
	line-height: 20px;
}
.Ranking li .img{
	width: 100px;
	height: 100px;
	padding: 4px;
	position: relative;
	background: #f2ce7f;
	border-radius: 50%;
	box-sizing: border-box;
	margin:0 auto 24px;
}
.Ranking li .img .head{
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 50%;
}
.Ranking .img .index{
	width: 26px;
	height: 26px;
	position: absolute;
	bottom: -14px;
	left: 50%;
	margin-left: -13px;
}
.Ranking li.one{
	width: 37%;
}
.Ranking li.one .img{
	transform: translateY(-5px);
	width: 120px;
	height: 120px;
}
.Ranking li.one .index{
	width: 33px;
	height: 33px;
	margin-left: -16.5px;
}
.Ranking li h4{
	font-size: 13px;
}
.Ranking li P{
	color: #f2ce7f;
	font-size: 15px;
	line-height: 30px;
}
.Ranking li .btn{
	width: 70px;
	margin: 0 auto;
	border-radius: 15px;
}

.list{
    margin-top: 15px;
}
.list li{
    border:1px solid #eac470;
    padding: 12px;
    position: relative;
    background: #36363a;
    height: 118px;
    margin-bottom: 20px;
    color: #fff;
    box-sizing: border-box;
}
.list .btn{
    position: absolute;
    bottom: 10px;
    right:12px;
    border-radius: 15px;
    width: 100px;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
}
.list .img{
    width: 94px;
    height: 94px;
    line-height:94px;
    overflow: hidden;
    text-align: center;
    display: block;
    float: left;
}
.list .img img{
    width: 94px;
    height: 94px;
}
.list .content{
    padding-left: 104px;
}
.list h4{
   line-height: 16px;
    padding: 10px 0;
    height: 52px;
    box-sizing: border-box;
}
.list h4 p{
    overflow: hidden;
}
.list h4 span{
    text-align: right;
    width: 50px;
    float: right;
    font-size: 12px;
    color: #d5d5d5;
}
.list .number{
    line-height: 22px;
}
.list .number span{
    color: #d1b168;margin-left: 4px;
}
.rules{
	margin: 10px auto;
	background: #fff;
	padding: 20px 10px;
	border-radius: 5px;
	color: #333333;
	line-height: 25px;
	min-height: 300px;
}
.voteingBox .title{
	height: 38px;
	line-height: 38px;
	background: #f0f0f0;
	color: #323232;
	text-align: center;
	font-size: 15px;
}
.voteing{
	padding: 20px 30px;
}
.voteing .ticktes{
	margin: 0 -16px;
	display: flex;
	flex-wrap:wrap;
}
.voteing li{
	flex: 1;
	text-align: center;
	min-width: 25%;
	max-width: 25%;
	margin-bottom: 10px;
}
.voteing li .img{
	width: 80%;
	line-height: 76px;
	margin: 0 auto;
	border: 1px solid #e1e1e1;
	border-radius: 3px;
	overflow: hidden;
}
.voteing li.cur .img{
	border: 1px solid #e5be68;
}
.voteing li .img.cur{
	border: 2px solid #eed49a;
}
.voteing li .img img{
	max-width: 80%;
	vertical-align: middle;
}
.voteing li h4{
	font-size: 13px;
	line-height: 20px;
}
.voteing li p{
	font-size: 12px;
	color: #d4ae5a;
}
.count{
	text-align: center;
	margin: 15px auto;
	height: 27px;
	width: 150px;
}
.count .add,.count .cut{
	height: 27px;
	width: 27px;
	line-height: 27px;
	color: #fff;
	background: #dcb45a;
	font-size: 30px;
	display: inline-block;
	vertical-align: top;
	border-radius: 3px;
}
.count input{
	display: inline-block;
	width: 65px;
	height: 25px;
	line-height: 25px;
	border: 1px solid #d4d4d4;
	color: #656565;
	background: none;
	padding: 0;
	border-radius: 3px;
	text-align: center;
	padding: 0 3px;
}
.voteing .btn{
	height: 42px;
	line-height: 42px;
}
.count .disabled{
	background: #d0d0d0;
}
</style>